<template>
  <div v-if="membership" class="d-flex flex-column membership-cont gap-2">
    <div class="label">
      <b>{{ membership.membership_program_name }}</b>
      <span v-if="membership.auto_renews" class="hint-label">{{
        renewsText
      }}</span>
    </div>
    <div v-if="membership.auto_renews" class="two-rows">
      <div class="single-row">
        <div class="d-flex mr-3">
          <span class="label">Covered System(s):</span>
          <span>{{ membership.covered_systems || "--" }}</span>
        </div>
        <div class="d-flex mr-3">
          <span class="label">Charge on Renewal:</span>
          {{ dollars(membership.price_cents) }}
        </div>
      </div>
      <div class="single-row flex-wrap items-center gap-3">
        <div class="d-flex">
          <span class="label">Starts On:</span>
          {{ shortDate(membership.starts_at) }}
        </div>
        <div class="d-flex">
          <span class="label">Next Billing Date:</span>
          {{ shortDate(membership.renews_at) }}
        </div>
        <div
          v-if="membership.auto_renews"
          class="flex flex-col md:flex-row md:items-center"
        >
          <p class="label">Cancellation Date:</p>
          <Datepicker
            v-model="cancelDate"
            name="Cancellation Date"
            placeholder="MM/DD/YY"
            class="mb-0 date-picker"
            no-label
          />
        </div>
      </div>
    </div>
    <div v-else class="single-row">
      <div class="d-flex mr-3">
        <span class="label">Covered System(s):</span>
        <span>{{ membership.covered_systems || "--" }}</span>
      </div>
      <div class="d-flex mr-3 mb-2">
        <span class="label">Starts On:</span>
        {{ shortDate(membership.starts_at) }}
      </div>
      <div class="d-flex mr-3">
        <span class="label">Ends On:</span>
        {{ shortDate(membership.ends_at) }}
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "@/components/Datepicker.vue";
import useVuelidate from "@vuelidate/core";
export default {
  components: {
    Datepicker
  },
  props: {
    membership: {
      type: Object,
      default: null
    },
    modelValue: {
      type: [Date, String],
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  computed: {
    cancelDate: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    },
    renewsText() {
      return `(${this.displayMembershipDuration(this.membership)})`;
    },
    endTag() {
      return this.membership.auto_renews ? "Cancellation Date:" : "Ends On:";
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  white-space: nowrap;
  margin-right: 5px;
}
.date-picker {
  width: 105px !important;
}

.single-row {
  display: flex;
}

.two-rows {
  display: flex;
  flex-direction: column;
}
</style>
